/** Helpers de sesión y rol. El rol se guarda al iniciar sesión. */
import { isOnline } from '@/utils/connectivity';
import { disconnectPedidosSocket } from '@/utils/pedidosSocket';

export function getModulos() {
    try {
        const raw = localStorage.getItem('modulos');
        if (!raw) return [];
        const parsed = JSON.parse(raw);
        return Array.isArray(parsed) ? parsed : [];
    } catch {
        return [];
    }
}

export function setModulosSession(modulos) {
    if (Array.isArray(modulos)) {
        localStorage.setItem('modulos', JSON.stringify(modulos));
    }
}

export function getRol() {
    const r = localStorage.getItem('rol');
    if (r) return r;
    return localStorage.getItem('usuario') === 'admin' ? 'admin' : 'negocio';
}

export function getUsuario() {
    return localStorage.getItem('usuario') || '';
}

export function getLogin() {
    return localStorage.getItem('login') || getUsuario();
}

export function getNombre() {
    return localStorage.getItem('nombre') || '';
}

export function getVendedorNombre() {
    return localStorage.getItem('vendedorNombre') || '';
}

export function isAdmin() {
    return getRol() === 'admin';
}

export function isVendedor() {
    return getRol() === 'vendedor';
}

export function isNegocio() {
    return getRol() === 'negocio';
}

/** Quien puede gestionar al negocio (negocio dueño o admin), no el vendedor. */
export function puedeGestionarNegocio() {
    const r = getRol();
    return r === 'negocio' || r === 'admin';
}

export function clearSession() {
    try {
        disconnectPedidosSocket();
    } catch (_) {
        /* ignore */
    }
    localStorage.clear();
}

/**
 * Cierra sesión del panel. Offline no permite logout: se pierde acceso al POS
 * y a las ventas pendientes en IndexedDB.
 * @returns {boolean} true si se cerró sesión
 */
export function cerrarSesionPanel(router) {
    if (!isOnline()) {
        return false;
    }
    clearSession();
    if (router && typeof router.push === 'function') {
        router.push('/');
    }
    return true;
}

/** true si no hay token o el JWT ya venció (exp). */
export function tokenExpirado(token) {
    if (!token || typeof token !== 'string') return true;
    try {
        const parts = token.split('.');
        if (parts.length < 2) return true;
        const payload = JSON.parse(atob(parts[1].replace(/-/g, '+').replace(/_/g, '/')));
        if (!payload.exp) return false;
        return Date.now() >= payload.exp * 1000;
    } catch {
        return true;
    }
}

/** Limpia sesión y redirige al login si el token venció. Devuelve true si expiró. */
export function cerrarSesionSiTokenExpirado(router) {
    const token = localStorage.getItem('token');
    if (!token) return false;
    if (!tokenExpirado(token)) return false;
    if (!isOnline()) {
        const path = router.currentRoute && router.currentRoute.value && router.currentRoute.value.path;
        if (path && ['/u/pos', '/u/cobros', '/u/home'].some((p) => path === p || path.startsWith(`${p}/`))) {
            return false;
        }
    }
    clearSession();
    if (router && typeof router.push === 'function') {
        const onLogin = router.currentRoute && router.currentRoute.value && router.currentRoute.value.path === '/u/login';
        if (!onLogin) {
            router.push('/u/login');
        }
    }
    return true;
}
